<template>
  <div class="filter-bar filter-bar-stacked">
    <v-select
      :options="statusList"
      v-model="selectedStatusModel"
      placeholder="Status"
    />
    <v-select
      :options="clientList"
      label="name"
      v-model="selectedClientModel"
      placeholder="Cliente"
    />
    <v-select
      v-if="userIsAdmin"
      :options="lashList"
      label="name"
      v-model="selectedLashModel"
      placeholder="Lash"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'AppointmentFilters',
  components: { vSelect },
  props: {
    statusList: { type: Array, required: true },
    selectedStatus: { type: String, required: true },
    clientList: { type: Array, required: true },
    selectedClient: { type: [Object, null], default: null },
    lashList: { type: Array, required: true },
    selectedLash: { type: [Object, null], default: null },
    userIsAdmin: { type: Boolean, default: false },
  },
  emits: ['update:selectedStatus', 'update:selectedClient', 'update:selectedLash'],
  computed: {
    selectedStatusModel: {
      get() { return this.selectedStatus; },
      set(v) { this.$emit('update:selectedStatus', v); },
    },
    selectedClientModel: {
      get() { return this.selectedClient; },
      set(v) { this.$emit('update:selectedClient', v); },
    },
    selectedLashModel: {
      get() { return this.selectedLash; },
      set(v) { this.$emit('update:selectedLash', v); },
    },
  },
};
</script>
